import { LOGOUT } from './types';

const initialState = {
	token: localStorage.getItem('token'),
};

export default function (state = initialState, action) {
	const { type, payload } = action;

	switch (type) {
		case LOGOUT:
			localStorage.clear();
		default:
			return state;
	}
}
